import { useEffect } from 'react';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export const useFireManyIssueTrackingAnalaytics = (numIssues: number): void => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	useEffect(() => {
		if (numIssues > 100) {
			fireTrackAnalytics(createAnalyticsEvent({}), 'designAssociatedIssues exceeded', {
				numIssues,
			});
		}
	}, [createAnalyticsEvent, numIssues]);
};
